// Port of Flutter's DeviceNameClass (roomScreenFunctions.dart) — the "Enter Room
// Name" sheet. Creating a room is two calls: AddRooms returns an insertId, which
// is then mapped to the user + location via AddLocationRoomsMapping.

import React, { useState } from 'react';
import {
  Dialog, DialogContent, TextField, Button, Typography, Box, useTheme,
} from '@mui/material';
import { useApp } from '../../../core/state/AppContext';
import { addRoom, addLocationRoomsMapping } from '../../../core/api/api';
import { useMessage } from './MessageDialog';

export default function AddRoomDialog({ open, locationId, onClose, onAdded }) {
  const theme = useTheme();
  const c = theme.sli;
  const { userId } = useApp();
  const { show } = useMessage();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const roomName = name.trim();
    if (!roomName) {
      show('Invalid Name', 'Room Name cannot be empty');
      return;
    }
    setBusy(true);
    try {
      const res = await addRoom(roomName, locationId);
      const insertId = res?.data?.insertId;
      if (insertId == null) throw new Error('no insertId');
      await addLocationRoomsMapping(userId, locationId, insertId);
      setName('');
      onAdded();
    } catch (e) {
      show("Can't Add Rooms",
        "The room couldn't be added properly, contact assistance to solve your issue.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { bgcolor: c.back, borderRadius: '20px', width: 'min(80vw, 400px)' } }}
    >
      <DialogContent sx={{ p: 2.5 }}>
        <Typography sx={{ fontSize: 20, fontWeight: 700, color: c.text, textAlign: 'center' }}>
          Enter Room Name
        </Typography>
        <Box sx={{ height: 20 }} />
        <TextField
          autoFocus
          fullWidth
          placeholder="Here..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              color: c.text,
              '& fieldset': { borderColor: `${c.text}66` },
              '&.Mui-focused fieldset': { borderColor: c.text },
            },
            '& input::placeholder': { color: `${c.text}99`, opacity: 1 },
          }}
        />
        <Box sx={{ height: 20, display: 'flex' }} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.25 }}>
          <Button onClick={onClose} sx={{ color: c.text }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={submit}
            disabled={busy}
            sx={{ bgcolor: c.button, color: '#fff', borderRadius: '12px' }}
          >
            Submit
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
